import { DESC_TYPE } from "../../components/TaskSidebar/sidebar.constants";
import { openSidebar } from "../../components/Tasks/tasks.service";
import { number } from "../../config";
import { SMART_CHIP_REGEX, TASK_CHIP_REGEX } from "../editor.helper";

/**
 * Function to handle clicking on a smart chip.
 */
export const handleSmartChipClick = (
  event,
  editableRef,
  setShowEditChip,
  setSmartChipId,
  setEditChip,
  popupVisible,
  setPopupVisible,
  popupAnchor,
  setPopupAnchor,
  taskKey
) => {
  const { target } = event;
  const id = target.id;
  if (target.localName === "span" && id && id.match(SMART_CHIP_REGEX) && editableRef.current && taskKey !== DESC_TYPE.WF_DESCRIPTION) {
    setShowEditChip(true);
    setSmartChipId(id);
    setEditChip(target);
  }
  if (target.localName === "span" && id && id.match(SMART_CHIP_REGEX) && !editableRef.current) {
    const match = id.match(TASK_CHIP_REGEX);
    if (match && match[number.ONE]) {
      const taskId = match[number.ONE];
      openSidebar({ id: taskId });
    }
  }
  if (target.localName === "i" || target.localName === "svg" || target.localName === "path") {
    if(target.localName === "path") {
      setPopupAnchor(target.parentElement);
    } else if(target.localName === "i") { 
      setPopupAnchor(target.children[0]);
    } else {
      setPopupAnchor(target);
    }
    setPopupVisible(true);
  }
};

/**
 * Function to handle clicking on an anchor tag.
 * @param {Event} event - The click event.
 */
export const handleAnchorClick = (event, editableRef, dispatch, history) => {
  const { target } = event;
  const currentHostname = window.location.hostname;
  if (target.localName === "a") {
    event.preventDefault();
  }
};
